module.exports = __webpack_public_path__ + "img/Main-Page-UTS-Still.f07f9e84.jpg";